import Language from "./language";
import ITranslation from "../interface/translation";
import Message from "../enum/message";
import Translations from "../data/translations";

class MessageSingleton {

    public get(msg: Message): string {
        const t: ITranslation | null = Language.getTranslation(Language.get());
        if (t) {
            return t.msg[msg];
        }
        return msg;
    }

    public getAll(msg: Message): string[] {
        const result: string[] = [];
        Translations.forEach((t: ITranslation) => result.push(t.msg[msg]));
        return result;
    }

}

const Msg = new MessageSingleton();

export default Msg;